import { render } from "./Sidebar.vue?vue&type=template&id=84c4cf6e"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=84c4cf6e&lang=scss"
script.render = render

export default script